import { List, ListItem, MenuItem, Select } from '@mui/material';
import React, { useState } from 'react';

import useDropdownTitleStyles from './styles';
import { DropdownTitleProps } from './types';

const DropdownTitle: React.FunctionComponent<DropdownTitleProps> = (props) => {
  const { title, onChange, dropDownOptions } = props;

  const [selectedValue, setSelectedValue] = useState<string>('');

  const classes = useDropdownTitleStyles(props);

  const renderDropDownOptions = () => {
    return dropDownOptions?.map((option, index) => {
      return (
        <MenuItem key={`titleMenuItem_${index}`} value={option.value}>
          {option.label}
        </MenuItem>
      );
    });
  };

  const renderDropdownTitle = () => {
    return (
      <Select
        variant='standard'
        classes={{ select: classes.select }}
        displayEmpty
        value={selectedValue}
        onChange={(event) => {
          const value = event.target.value;
          setSelectedValue(value);
          onChange(event.target.value);
        }}
        renderValue={() => (
          <List sx={{ padding: 0 }}>
            <ListItem classes={{ root: classes.selectedMenuItem }}>
              {!!selectedValue
                ? dropDownOptions?.find((option) => option.value === selectedValue)?.label
                : title}
            </ListItem>
          </List>
        )}
      >
        {renderDropDownOptions()}
      </Select>
    );
  };

  return renderDropdownTitle();
};

export default DropdownTitle;
